import classNames from 'classnames'
import { withStyles } from '@material-ui/core'
import { default as ReactPlacesAutoComplete } from 'react-places-autocomplete'

const styles = () => ({
  dropDownContainer: {
    boxShadow: '0 0 5px',
    position: 'absolute', // so it doesn't push the contents down
    width: '100%', // display full width as per the ouer div whose position is relative
    zIndex: 2
  }
})

const LocationAutoCompleteField = ({
  label,
  classes,
  value,
  handleChange,
  handleSelect,
  employerSide
}) => {
  return (
    <>
      <label
        style={{
          color: 'rgba(0, 0, 0, 0.54)',
          marginBottom: '0',
          fontWeight: 500
        }}
      >
        {label}
      </label>
      <ReactPlacesAutoComplete
        value={value}
        className={classNames(classes.textField, classes.resize)}
        onChange={handleChange(employerSide ? 'location' : 'city_name')}
        onSelect={handleSelect(employerSide ? 'location' : 'city_name')}
        searchOptions={{
          types: ['(regions)'],
          componentRestrictions: { country: 'fi' }
        }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div style={{ position: 'relative' }}>
            <input
              {...getInputProps({
                className: 'location-search-input mt-1 full-width input-form',
                style: {
                  fontSize: '15px',
                  width: '100%',
                  lineHeight: '2em',
                  border: '1px solid gray',
                  paddingLeft: '5px'
                }
              })}
            />

            <div
              className={classes.dropDownContainer}
              style={{
                boxShadow: '0 0 5px',
                position: 'absolute', // so it doesn't push the contents down
                width: '100%', // display full width as per the ouer div whose position is relative
                zIndex: 2
              }}
            >
              {loading && (
                <div style={{ fontSize: '14px', padding: '10px' }}>
                  Loading...
                </div>
              )}
              {suggestions.map((suggestion, index) => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item'
                const style = suggestion.active
                  ? {
                      backgroundColor: '#fafafa',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }
                  : {
                      backgroundColor: '#ffffff',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style
                    })}
                    key={index}
                  >
                    <span style={{ padding: '10px' }}>
                      {suggestion.description}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </ReactPlacesAutoComplete>
    </>
  )
}

export default withStyles(styles)(LocationAutoCompleteField)
